import { render } from "./DeadLeadGenerationReport.vue?vue&type=template&id=4d178dd0&scoped=true"
import script from "./DeadLeadGenerationReport.vue?vue&type=script&lang=js"
export * from "./DeadLeadGenerationReport.vue?vue&type=script&lang=js"

import "./DeadLeadGenerationReport.vue?vue&type=style&index=0&id=4d178dd0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d178dd0"]])

export default __exports__